export default __webpack_public_path__ + "static/media/Pig.f6398948.svg";